(function () {
	let featuredCollectionSlide = () => {
		let carousel = $(".collection-product-list").flickity({
			autoPlay: false,
			pageDots: false,
			draggable: true,
			prevNextButtons: false,
			cellAlign: "left",
			groupCells: true
		});

		$(".collection-product-list__button--next").click(function () {
			carousel.flickity("next");
		});

		$(".collection-product-list__button--prev").click(function () {
			carousel.flickity("previous");
		});
	};

	const calcHeight = () => {
		const card = document.querySelector(".featured-collection-section__card");
		const featuredcollectionSection = document.querySelector(
			".featured-collection-section",
		);
		const cardRect = card.getBoundingClientRect();
		const cardHeight = cardRect.height;
		featuredcollectionSection.style.paddingBottom = `${cardHeight / 2}px`;
	};

	document.addEventListener("shopify:section:load", function () {
		featuredCollectionSlide();
		calcHeight();
	});

	featuredCollectionSlide();
	calcHeight();
})();
